import { useState } from "react";
import { login } from "../api/auth";
import { AuthLoginRequest, AuthLoginResponse } from "../api/auth/types";
import { useAppDispatch } from "../store";
import { setUser } from "../store/slices/user";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (data: AuthLoginRequest) => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await login(data);
      const payload: AuthLoginResponse = response.data;
      const token = payload.access_token;
      const first_name = payload.first_name;
      const last_name = payload.last_name;
      const role = payload.role;
      const department_id = payload.department_id;
      const channel_id = payload.channel_id;

      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("first_name", first_name);
        localStorage.setItem("last_name", last_name);
        localStorage.setItem("role", role);
        localStorage.setItem("department_id", String(department_id));
        localStorage.setItem("channel_id", String(channel_id));
        dispatch(
          setUser({
            id: payload.id,
            username: payload.username,
            first_name: payload.first_name,
            last_name: payload.last_name,
            department_id: payload.department_id,
            channel_id: payload.channel_id,
            role: payload.role,
            access_token: payload.access_token,
            refresh_token: payload.refresh_token,
          }),
        );
        return true;
      }

      return false;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Произошла ошибка при входе");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleLogin,
    isLoading,
    error,
  };
};
